import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Stack, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material_modern'

const AxleWeightsHeader = ({ numberOfAxles, setNumberOfAxles, disabled }) => {
  const { t } = useTranslation('inboundTicket')

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" pb={2}>
      <Typography variant="h6">{t('split_axle_weights')}</Typography>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="body2" pr={1} color="text.hint">
          {t('axles')}
        </Typography>
        <ToggleButtonGroup
          value={numberOfAxles}
          exclusive
          onChange={(_, value) => {
            if (value) {
              setNumberOfAxles(value)
            }
          }}
          disabled={disabled}
        >
          <ToggleButton sx={{ width: '48px' }} value={1}>
            OFF
          </ToggleButton>
          <ToggleButton sx={{ width: '48px' }} value={2}>
            2
          </ToggleButton>
          <ToggleButton sx={{ width: '48px' }} value={3}>
            3
          </ToggleButton>
          <ToggleButton sx={{ width: '48px' }} value={4}>
            4
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Stack>
  )
}

AxleWeightsHeader.propTypes = {
  numberOfAxles: PropTypes.number.isRequired,
  setNumberOfAxles: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

AxleWeightsHeader.defaultProps = {
  disabled: false,
}

export default AxleWeightsHeader
